<template>
    <!-- Breadcrumb Section Start -->
    <section class="breadscrumb-section pt-0">
        <div class="container-fluid-lg">
            <div class="row">
                <div class="col-12">
                    <div class="breadscrumb-contain">
                        <h2>{{ $t('Sign Up') }}</h2>
                        <nav>
                            <ol class="breadcrumb mb-0">
                                <li class="breadcrumb-item active">{{ $t('Sign Up') }}</li>
                                <li class="breadcrumb-item">
                                    <router-link :to="{name: 'home', params: { lang : $i18n.locale }}">
                                        <i class="fa-solid fa-house"></i>
                                    </router-link>
                                </li>
                            </ol>
                        </nav>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <!-- Breadcrumb Section End -->

    <!-- log in section start -->
    <section class="log-in-section section-b-space">
        <div class="container-fluid-lg w-100">
            <div class="row">
                <div class="col-xxl-6 col-xl-5 col-lg-6 d-lg-block d-none ms-auto">
                    <div class="image-contain">
                        <img src="/theme/assets/images/inner-page/sign-up.png" class="img-fluid" alt="">
                    </div>
                </div>

                <div class="col-xxl-4 col-xl-5 col-lg-6 col-sm-8 mx-auto">
                    <div class="log-in-box">
                        <div class="log-in-title">
                            <h3> {{ $t('Welcome To') }} {{ main?.settings?.name }}</h3>
                            <h4>{{ $t('Register your account') }}</h4>
                        </div>

                        <div v-if="error !== null" class="alert alert-danger alert-dismissible fade show" role="alert">
                            <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>

                            <strong>{{ error }}</strong>
                        </div>

                        <div class="input-box">

                            <form class="row g-4" @submit.prevent="register()">

                                <div class="col-12">
                                    <div class="form-floating theme-form-floating log-in-form">
                                        <input type="text" class="form-control pe-1" id="login-name"
                                               aria-label="name" aria-describedby="name" v-model="user.name" required>

                                        <label for="login-name">{{ $t('Name') }}</label>
                                    </div>
                                </div>

                                <div class="col-12">
                                    <div class="form-floating theme-form-floating log-in-form">
                                        <input type="number" class="form-control pe-1" id="login-mobile"
                                               placeholder="5×××××"
                                               aria-label="mobile" aria-describedby="mobile" v-model="user.mobile"
                                               dir="ltr" >

                                        <label for="login-mobile">{{ $t('Phone number') }}</label>
                                    </div>
                                </div>
                                <div class="col-12">
                                    <div class="form-floating theme-form-floating log-in-form">
                                        <input type="email" class="form-control pe-1" id="login-email"
                                               aria-label="email" aria-describedby="email" v-model="user.email"
                                               >

                                        <label for="login-email">{{ $t('Email') }}</label>
                                    </div>
                                </div>

                                <div class="col-12">
                                    <div class="form-floating theme-form-floating log-in-form">
                                        <input type="password" class="form-control pe-1" id="login-password"
                                               aria-label="password" aria-describedby="password" v-model="user.password"
                                               required>

                                        <label for="login-password">{{ $t('Password') }}</label>
                                    </div>
                                </div>
                                <!--  <div class="col-12">
                                     <div class="form-floating theme-form-floating log-in-form">
                                         <input type="password" class="form-control pe-1" id="login-password"
                                                aria-label="password" aria-describedby="password" v-model="user.password_confirm" required>

                                         <label for="login-password">{{ $t('Password confirm') }}</label>
                                     </div>
                                 </div> -->


                                <!--                                    <div class="col-12">-->
                                <!--                                        <div class="forgot-box">-->
                                <!--                                            <div class="form-check ps-0 m-0 remember-box">-->
                                <!--                                                <input class="checkbox_animated check-box" type="checkbox"-->
                                <!--                                                       id="flexCheckDefault">-->
                                <!--                                                <label class="form-check-label" for="flexCheckDefault">I agree with-->
                                <!--                                                    <span>Terms</span> and <span>Privacy</span></label>-->
                                <!--                                            </div>-->
                                <!--                                        </div>-->
                                <!--                                    </div>-->

                                <div class="col-12">
                                    <button class="btn btn-animation w-100" type="submit">{{ $t('Sign Up') }}</button>
                                </div>
                            </form>
                        </div>

                        <div class="other-log-in">
                            <h6></h6>
                        </div>

                        <div class="sign-up-box">
                            <h4>{{ $t('Already have an account?') }}</h4>
                            <router-link :to="{ name:'login', params: { lang : $i18n.locale } }">{{ $t('Sign in') }}
                            </router-link>
                        </div>
                    </div>
                </div>

                <div class="col-xxl-7 col-xl-6 col-lg-6"></div>
            </div>
        </div>
    </section>
    <!-- log in section end -->
</template>

<script>
import {useToast} from "vue-toastification";

const toast = useToast();

export default {
    props: ['main'],
    inject: ['auth'],
    data() {
        return {
            form_options: {},
            user: {
                agree: false
            },
            show_password: false,
            validationErrors: null,
            error: null
        }
    },

    created() {

        // const id = toast.info(this.$t('getting options ...'),{ icon: 'fa-light fa-filter-list'  });
        //
        // const that = this;
        //
        // axios.get('users/create').then(response => {
        //     toast.dismiss(id);
        //     this.form_options = response.data.elements;
        // }) .catch(function (error) {
        //     toast.dismiss(id);
        //     if (error.response) {
        //         that.validationErrors = error.response.data.errors ;
        //     }
        // });

    },
    methods: {
        isInvalid(name) {
            return this.validationErrors != null ? this.validationErrors[name]?.join() : false;
        },
        register() {

            const that = this;
            this.validationErrors = null;

            const id = toast.info(this.$t('Registration in progress.'), {
                timeout: 2000
            });

            this.auth.register({
                'data': this.user,
                'on_success': function (response) {

                    toast.success(response.data.message, {
                        timeout: 3000,
                    }, {icon: 'fa-solid fa-circle-check'});

                    that.user = {};
                    that.$router.push({name: 'activation', params: {lang: that.$i18n.locale}});

                },
                'on_fail': function (message, response) {
                    that.error = message;
                    if (response != null) {
                        that.validationErrors = response.data.errors;
                    }
                },
                'on_completed': function () {
                    toast.dismiss(id);
                },

            });

        }
    },

}
</script>
